/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_Confirm_TextInputs */

const en_cancel_confirm_text = /** @type {(inputs: Cancel_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your subscription will remain active until the end of the current billing period. Are you sure you want to cancel?`)
};

const fr_cancel_confirm_text = /** @type {(inputs: Cancel_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre abonnement restera actif jusqu'à la fin de la période de facturation en cours. Êtes-vous sûr de vouloir l'annuler ?`)
};

const de_cancel_confirm_text = /** @type {(inputs: Cancel_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr Abonnement bleibt bis zum Ende des aktuellen Abrechnungszeitraums aktiv. Möchten Sie es wirklich kündigen?`)
};

const it_cancel_confirm_text = /** @type {(inputs: Cancel_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo abbonamento rimarrà attivo fino alla fine del periodo di fatturazione corrente. Vuoi davvero annullarlo?`)
};

const ru_cancel_confirm_text = /** @type {(inputs: Cancel_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваша подписка останется активной до конца текущего расчетного периода. Вы уверены, что хотите отменить подписку?`)
};

const es_cancel_confirm_text = /** @type {(inputs: Cancel_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu suscripción permanecerá activa hasta el final del periodo de facturación actual. ¿Estás seguro de que deseas cancelarla?`)
};

const zh_cn2_cancel_confirm_text = /** @type {(inputs: Cancel_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的订阅将持续有效至当前计费周期结束。您确定要取消吗？`)
};

const ja_cancel_confirm_text = /** @type {(inputs: Cancel_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプションは現在の請求期間の終了まで有効です。キャンセルしてもよろしいですか？`)
};

const hi_cancel_confirm_text = /** @type {(inputs: Cancel_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपकी सदस्यता वर्तमान बिलिंग अवधि के अंत तक सक्रिय रहेगी। क्या आप वाकई इसे रद्द करना चाहते हैं?`)
};

const pt_pt2_cancel_confirm_text = /** @type {(inputs: Cancel_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua assinatura permanecerá ativa até o final do período de faturamento atual. Tem certeza de que deseja cancelar?`)
};

/**
* | output |
* | --- |
* | "Your subscription will remain active until the end of the current billing period. Are you sure you want to cancel?" |
*
* @param {Cancel_Confirm_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cancel_confirm_text = /** @type {((inputs?: Cancel_Confirm_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_Confirm_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_cancel_confirm_text(inputs)
	if (locale === "de") return de_cancel_confirm_text(inputs)
	if (locale === "it") return it_cancel_confirm_text(inputs)
	if (locale === "ru") return ru_cancel_confirm_text(inputs)
	if (locale === "es") return es_cancel_confirm_text(inputs)
	if (locale === "zh-CN") return zh_cn2_cancel_confirm_text(inputs)
	if (locale === "ja") return ja_cancel_confirm_text(inputs)
	if (locale === "hi") return hi_cancel_confirm_text(inputs)
	if (locale === "pt-PT") return pt_pt2_cancel_confirm_text(inputs)
	return en_cancel_confirm_text(inputs)
});